/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { Record } from 'immutable'
import ReservationEvent from '../../event/ReservationEvent'

const ReservationToolbar = Record({
  saveButtonDisabled: false
})

class ToolbarStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new ReservationToolbar()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case ReservationEvent.requestSave:
        return state.merge({ saveButtonDisabled: payload.disabled })

      default:
        return state
    }
  }
}

export default new ToolbarStore()
